var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_940_8566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6479 70H21.3521C20.808 70 20.2865 69.784 19.902 69.3993L0.600742 50.0981C0.216016 49.7135 0 49.192 0 48.6479V21.3521C0 20.808 0.216016 20.2865 0.600742 19.902L19.9019 0.600742C20.2865 0.216016 20.808 0 21.3521 0H48.6479C49.192 0 49.7135 0.216016 50.098 0.600742L69.3993 19.902C69.7838 20.2866 70 20.8082 70 21.3521V48.6479C70 49.192 69.784 49.7135 69.3993 50.098L50.0981 69.3993C49.7135 69.784 49.192 70 48.6479 70Z",
    fill: "#FF674F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.648 70C49.192 70 49.7135 69.784 50.098 69.3993L69.3993 50.098C69.7838 49.7134 70 49.1918 70 48.6479V21.3521C70 20.808 69.784 20.2865 69.3993 19.902L50.0981 0.600742C49.7135 0.216016 49.192 0 48.648 0H35V70H48.648Z",
    fill: "#F2472C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.024 43.4019H30.9761C30.1696 43.4019 29.5059 42.7671 29.4699 41.9614L28.1671 12.765C28.0906 11.0486 29.4614 9.61523 31.1794 9.61523H38.8205C40.5385 9.61523 41.9094 11.0486 41.8328 12.765L40.5301 41.9614C40.4941 42.7671 39.8305 43.4019 39.024 43.4019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0009 60.3846C31.9823 60.3846 29.5352 57.9375 29.5352 54.9189C29.5352 51.9003 31.9823 49.4531 35.0009 49.4531C38.0195 49.4531 40.4666 51.9003 40.4666 54.9189C40.4666 57.9375 38.0195 60.3846 35.0009 60.3846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 49.4536V60.3851C38.0183 60.3847 40.4652 57.9378 40.4652 54.9194V54.9192C40.4651 51.9009 38.0183 49.454 35 49.4536Z",
    fill: "#FFEDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8199 9.61523H35V43.4019H39.0232C39.8297 43.4019 40.4935 42.7672 40.5295 41.9614L41.8322 12.765C41.9089 11.0486 40.5381 9.61523 38.8199 9.61523Z",
    fill: "#FFEDCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_940_8566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseJob);
export default __webpack_public_path__ + "static/media/close_job.0fa1b001912ff02fb2117a5d2abf7914.svg";
export { ForwardRef as ReactComponent };